import { createSelector } from '@app/utils/createSelector'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

import { avatarsSelector } from './entities'

const avatarsSlice = createReduxSlice<{ list: string[] }>('profile_avatars')

export const uploadProfileAvatar = (file: File) =>
  createThunk(async dispatch => {
    const [{ postAvatars }, { callV2Api }] = await Promise.all([import('@app/packages/api/v2/actions/avatars'), import('@app/store/actions/api')])
    const resp = await dispatch(callV2Api(postAvatars(file)))
    dispatch(avatarsSlice.update(state => (state ? { list: [...state.list, resp.data.id] } : state)))
  })

export const removeProfileAvatar = (id: string) =>
  createThunk(async dispatch => {
    const [{ deleteAvatars }, { callV2Api }] = await Promise.all([import('@app/packages/api/v2/actions/avatars'), import('@app/store/actions/api')])
    await dispatch(callV2Api(deleteAvatars(id)))
    dispatch(avatarsSlice.update(state => (state ? { list: state.list.filter(avatarId => avatarId !== id) } : state)))
  })

/** What the profile read returned is the whole list — an absent avatars entry means none. */
export const setProfileAvatarsFromResponseSlice = (payload: { included?: { id: string; type: string }[] }) =>
  avatarsSlice.set({ list: (payload.included ?? []).filter(i => i.type === 'avatars').map(a => a.id) })

const profileAvatarIdsSelector = createSelector([avatarsSlice.selector], state => state?.list || [])

export const profileAvatarsSelector = createSelector([profileAvatarIdsSelector, avatarsSelector], (ids, avatars) => {
  return ids.map(id => {
    const av = avatars[id]
    if (!av) throw new Error(`Avatar with id ${id} not found`)
    return av
  })
})

export const profileAvatarSelector = createSelector([profileAvatarsSelector], avatars => avatars.at(0))

export const profileHasAvatarsSelector = createSelector([profileAvatarsSelector], avatars => !!avatars.length)
